import {
  URL_REGEX,
  EMAIL_REGEX,
  PASSWORD_REGEX,
  MOBILE_REGEX,
  ENGLISH_REGEX,
  POSTAL_CODE_REGEX,
  NATIONAL_CODE_REGEX,
  HOME_PHONE_REGEX,
  ENDS_WITH_MP3,
} from "./regex";
import { bytesToSize } from "./convert.js";

export const isValidUrl = (url) => {
  const urlRegex = new RegExp(URL_REGEX);
  return urlRegex.test(url);
};

export const isValidEmail = (email) => {
  const emailRegex = new RegExp(EMAIL_REGEX);
  return emailRegex.test(email);
};

export const isValidPassword = (password) => {
  const passwordRegex = new RegExp(PASSWORD_REGEX);
  return passwordRegex.test(password);
};

export const isValidName = (name) => {
  if (name.length > 255) {
    return false;
  } else {
    return true;
  }
};

export const isValidMobile = (mobile) => {
  const mobileRegex = new RegExp(MOBILE_REGEX);
  return mobileRegex.test(mobile);
};

export const isEnglishChars = (text) => {
  const englishRegex = new RegExp(ENGLISH_REGEX);
  return englishRegex.test(text);
};

export const isValidPostalCode = (postalCode) => {
  const postalCodeRegex = new RegExp(POSTAL_CODE_REGEX);
  return postalCodeRegex.test(postalCode);
};

export const isValidNationalCode = (nationalCode) => {
  const nationalCodeRegex = new RegExp(NATIONAL_CODE_REGEX);
  if (nationalCodeRegex.test(nationalCode)) return false;
  const check = +nationalCode[9];
  const sum =
    nationalCode
      .split("")
      .slice(0, 9)
      .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
};

export const isValidNationalIdentifier = (nationalIdentifier) => {
  const length = nationalIdentifier.length;
  if (length < 11 || parseInt(nationalIdentifier) === 0) return false;
  if (parseInt(nationalIdentifier.substr(3, 6)) === 0) return false;
  var check = parseInt(nationalIdentifier.substr(10, 1));
  var tenthDigit = parseInt(nationalIdentifier.substr(9, 1)) + 2;
  const pattern = [29, 27, 23, 19, 17];
  let sum = 0;
  for (let index = 0; index < 10; index++) {
    sum +=
      (tenthDigit + parseInt(nationalIdentifier.substr(index, 1))) *
      pattern[index % 5];
  }
  let modulus = sum % 11;
  if (modulus === 10) modulus = 0;
  return check === modulus;
};

export const isValidHomePhone = (phone) => {
  const homePhoneRegex = new RegExp(HOME_PHONE_REGEX);
  return homePhoneRegex.test(phone);
};

export const isValidFileType = (fileType) => {
  let allowedTypes = [
    "text/csv", //.csv
    "application/msword", //.doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //.docx
    "image/gif", //.gif
    "image/jpeg", //.jpeg .jpg
    "application/pdf", //.pdf
    "application/vnd.ms-powerpoint", //.ppt
    "image/svg+xml", //.svg
    "application/x-tar", //.tar
    "image/webp", //.webp
    "application/zip", //.zip
    "application/x-zip-compressed", //.zip
    "application/vnd.ms-excel", //.csv
    "video/mpeg", // .mpeg
    "application/x-rar-compressed", //.rar
    "application/rtf", //.rtf
    "audio/ogg", //.ogg
    "audio/mp3", //.mp3
    "video/ogg", //.ogv
    "image/png", //.png
    "application/vnd.ms-powerpoint",
    "application/x-7z-compressed",
    "video/3gpp",
    "video/mp4",
    "video/mpeg",
    "video/quicktime",
    "video/webm",
    "video/x-ms-wmv",
    "video/x-msvideo",
    "audio/mpeg",
    "audio/x-m4a",
  ];

  let allowedType = allowedTypes.filter((type) => type === fileType)[0];

  if (allowedType) {
    return true;
  } else {
    return false;
  }
};

export const isImageSizeValidForUpload = (size) => {
  const fileSizeInKiloBtytes = size / 1024;

  return fileSizeInKiloBtytes < 500;
};

export const isValidFileToUploadAsImage = (fileType) => {
  const validFileTypes = ["image/jpeg", "image/png", "image/jpg"];

  return validFileTypes.includes(fileType);
};

const whatIsFile = (file) => {
  let type = file.type;
  let images = [
      "image/webp", //.webp
      "image/png", //.png
      "image/svg+xml", //.svg
      "image/jpeg", //.jpeg .jpg
      "image/gif", //.gif
    ],
    videos = [
      "video/3gpp",
      "video/ogg",
      "video/mp4",
      "video/mpeg",
      "video/quicktime",
      "video/webm",
      "video/x-ms-wmv",
      "video/x-msvideo",
    ],
    audios = [
      "audio/mp3", //.mp3
      "audio/ogg", //.ogg
      "audio/mpeg",
      "audio/x-m4a",
    ],
    compresseds = [
      "application/x-zip-compressed", //.zip
      "application/x-rar-compressed", //.tar
      "application/zip", //.zip
      "application/x-zip-compressed", //.zip
      "application/x-tar", //.tar
      "application/x-7z-compressed",
    ],
    documents = [
      "application/pdf",
      "application/vnd.ms-excel", //.csv
      "application/msword", //.doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //.docx
      "application/rtf", //.rtf
      "application/vnd.ms-powerpoint",
    ];
  if (images.indexOf(type) !== -1) {
    return 0;
  } else if (videos.indexOf(type) !== -1) {
    return 1;
  } else if (audios.indexOf(type) !== -1) {
    return 2;
  } else if (compresseds.indexOf(type) !== -1) {
    return 3;
  } else if (documents.indexOf(type) !== -1) {
    return 4;
  }
};

export const verifyFileToOpen = (file) => {
  let fileType = whatIsFile(file);
  let fileData = "";

  fileData = window.URL.createObjectURL(file);

  const returnedData = {
    file,
    fileData,
    fileType,
  };
  switch (fileType) {
    case 0: // image files preview
      // remove loader
      returnedData.type = "image";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;
      break;
    case 1: // video files preview
      // remove loader

      returnedData.type = "video";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;
      break;
    case 2: // audio files preview
      returnedData.type = "audio";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;

      break;
    case 3: // compresseds files preview
      // remove loader

      returnedData.type = "compress";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;

      break;
    case 4: // documents files preview
      // remove loader

      returnedData.type = "file";
      returnedData.size = bytesToSize(file.size);
      returnedData.name = file.name;
      break;
    default:
      break;
  }

  return returnedData;
};

export const isEndedWithMp3Format = (input) => {
  const endsMp3Regex = new RegExp(ENDS_WITH_MP3);

  return endsMp3Regex.test(input);
};

export const isFileSizeValid = (bytes, max) => {
  const sizeInMb = Math.round(bytes / Math.pow(1024, 2), 2);

  return sizeInMb <= max;
};
